import { Injectable } from '@angular/core';
import { LoaderService } from '../loader.service';
import { UtilsController } from '../../controllers/utils/utils.controller';

@Injectable()
export class UtilsService {

    constructor(
        private _utilsController:UtilsController,
        private _loaderService:LoaderService,
    ) { }

    async status():Promise<any>{
        try{return await this._utilsController.status();}
        catch(error){console.log(error); return "";}
    }

    async initDDL(): Promise<string> {
        this._loaderService.show()
        return await this._utilsController.initDDL().finally(() => this._loaderService.hide())
    }
    
}